/**
 * Do not extend the real Error class it will cause errors
 */
export default class ExtendableError {
    constructor(message) {
        this.message = message
        this.name = this.constructor.name

        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, this.constructor)
        } else {
            this.stack = (new Error(message)).stack
        }
    }

    getMessage() {
        return this.message
    }
}
